import { Bounce, toast } from "react-toastify";

export const msgItemIdCopied = async (message: string) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 1500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
    transition: Bounce,
  });
};

export const displayWarning = async (message: string) => {
  toast.warn(message, {
    position: "top-right",
    autoClose: 1500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
    transition: Bounce,
    style: {
      color: "black",
    },
  });
};

export const displaySuccess = async (message: string) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 1500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
    transition: Bounce,
    style: {
      color: "black",
    },
  });
};

export const displayError = async (message: string) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 1500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
    transition: Bounce,
    style: {
      color: "black",
    },
  });
};

export const displayErrorExpired = async (message: string) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 1500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
    transition: Bounce,
    style: {
      color: "black",
    },
  });
};

const infoToastStyle = {
  color: "black",
  backgroundColor: "#34a1eb",
} as const;

export const displayInfo = async (message: string, time?: number) => {
  toast.success(message, {
    position: "top-right",
    autoClose: time || 1500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
    style: infoToastStyle,
  });
};

export const displaySessionRenewed = async (message = "Sessão renovada.") => {
  toast.success(message, {
    position: "top-right",
    autoClose: 2200,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
    transition: Bounce,
    style: infoToastStyle,
  });
};
